"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
function Chapter(_a) {
    var style = _a.style, onClick = _a.onClick, chapter = _a.chapter;
    return react_1.default.createElement("div", { className: 'storybook-timelines-chapter', style: { left: style }, onClick: onClick },
        react_1.default.createElement("span", { className: 'storybook-timelines-chapter-info' }, chapter.title),
        react_1.default.createElement("small", { className: 'text-primary' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'flag-solid', className: 'storybook-icons-icon inline-block' })));
}
exports.default = Chapter;
